module.exports = __webpack_public_path__ + "assets/checkmark_green-613fd1.svg";